import { useComponentLoadingStateStore } from "../store/useComponentLoadingStateStore";
import { Dialog, DialogTitle } from "@mui/material";
import Image from "next/image";
import { useEffect, useState } from "react";
import getOffersData from "../helpers/getOffersData";
import { useRouterStore } from "../store/useRouterStore";
import CloseIcon from "@mui/icons-material/Close";
const BoothOfferBanner = ({ isOpen = false }) => {
  const { setIsOffersBoxClicked } = useComponentLoadingStateStore();
  const { boothID } = useRouterStore();
  const [offerBanner, setOfferBanner] = useState("/bg-placeholder.png");

  useEffect(() => {
    if (boothID === "") return;
    getOffersData().then((res) => {
      res.forEach((offer) => {
        if (boothID === offer.standDescription && offer.banner) {
          setOfferBanner(offer.banner);
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boothID]);

  const handleClose = () => {
    setIsOffersBoxClicked(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      onChange={handleClose}
      fullWidth
      maxWidth={"xl"}
      PaperProps={{
        style: {
          height: "100vh",
        },
      }}
    >
      <DialogTitle>Offer Banner</DialogTitle>
      <CloseIcon
        sx={{
          position: "absolute",
          right: "10px",
          top: "20px",
          cursor: "pointer",
          zIndex: 1000000,
        }}
        onClick={handleClose}
      />
      <Image
        src={offerBanner}
        fill
        style={{ objectFit: "contain" }}
        alt="offer banner"
      />
    </Dialog>
  );
};

export default BoothOfferBanner;
